import http from '@/utils/http';
import i18n from '@/main';

export default {
    listarRepresentante() {
        return http.get({
            url: '/representantes',
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.adicionandoPessoa')
        });
    },
    cadastrarRepresentante(representante) {
        return http.post({
            url: '/representantes',
            data: { ...representante },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.adicionandoPessoa')
        });
    },
    cadastrarRepresentantePy(representante) {
        return http.post({
            url: '/representantes/inserirPY',
            data: { ...representante },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.adicionandoPessoa')
        });
    },
    cadastrarRepresentanteAr(representante) {
        return http.post({
            url: '/representantes/inserirAR',
            data: { ...representante },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.adicionandoPessoa')
        });
    },
    async detalhesRepresentante(representanteId) {
        return http.get({
            url: `/representantes/visualizar/editar/${representanteId}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoPessoas')
        });
    },
    findById(representanteId) {
        return http.get({
            url: `/representantes/${representanteId}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoPessoas')
        });
    },
    findAllByFiltro({ page, size, order, searchText, lockScreen = true }) {
        return http.get({
            url: `/representantes/filtrar/?page=${page}&size=${size}${order}&searchText=${searchText}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoPessoas')
        });
    },
    simplificado() {
        return http.get({
            url: '/representantes/simplificado',
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoPessoas')
        });
    },
    delete(representanteId) {
        return http.delete({
            url: '/representantes',
            data: { representanteId },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.removendoPessoa')
        });
    },
    editarRepresentante(representante) {
        return http.put({
            url: '/representantes',
            data: { ...representante },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.salvandoPessoaAtualizada')
        });
    },
    editarRepresentantePy(representante) {
        return http.put({
            url: '/representantes/editarPY',
            data: { ...representante },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.salvandoPessoaAtualizada')
        });
    },
    editarRepresentanteAr(representante) {
        return http.put({
            url: '/representantes/editarAR',
            data: { ...representante },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.salvandoPessoaAtualizada')
        });
    },
    buscarTipoDocumento() {
        return http.get({
            url: '/representantes/tipo-documento',
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoTiposDeDocumento')
        });
    },
    buscarPorNomeOuCpfCnpj(filtro) {
        return http.get({
            url: `/representantes/buscar/nome-cpfCnpj/${filtro}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoPessoas')
        });
    },
    buscarPorNomeOuCuit(filtro) {
        return http.get({
            url: `/representantes/buscar/nome-cuit/${filtro}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoPessoas')
        });
    },
    buscarPorNomeOuCuitSucursal(filtro, numeroContrato, idSucursal) {
        return http.get({
            url: `/representantes/buscar-persona-por-cuit/${numeroContrato}/${idSucursal}?filtro=${filtro}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoPessoas')
        });
    }
};
